module.exports = import("https://www.gstatic.com/firebasejs/10.7.0/firebase-storage.js");;